import styled, { css } from 'styled-components'
import React from 'react'
import { Link } from 'gatsby'
import { device } from '../../styles/Breakpoints'
import { Container } from '../../styles/Wrappers'
// import Column from './Column'

export const Grid = styled.div`
	padding: 0;
`

export const IntegrationsGrid = styled(Container)`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
	gap: 10px;

	@media ${device.sm} {
		gap: 20px;
		grid-template-columns: 1fr 1fr 1fr;
	}

	@media ${device.md} {
		grid-template-columns: 1fr 1fr 1fr 1fr;
	}

	@media ${device.lg} {
		grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
	}

	@media ${device.lg} {
		grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
	}
`

export const AllButton = styled.input`
	background-color: var(--green);
	color: #fff;
	border: none;
	width: 100%;
	padding: 10px;
`

export const FilterReset = styled.div`
	display: flex;
	flex: 1 0 100%;
	justify-content: flex-start;
	margin-top: 20px;
`

export const GridFilters = styled(Container)`
	display: flex;
	flex-flow: row wrap;
	justify-content: flex-start;
	align-items: center;
`

export const LinkedIntegrationsSquare = styled((props) => <Link {...props} />)`
	display: flex;
	flex-direction: column;
	border: 1px solid var(--grey-22);
	text-decoration: none;
	color: var(--dark-grey);
	position: relative;

	&:hover {
		border: 1px solid var(--green);
	}
`

export const IntegrationsSquare = styled.div`
	display: flex;
	position: relative;
	flex-direction: column;
	border: 1px solid var(--grey-22);
	text-decoration: none;
	color: var(--dark-grey);
`

export const IntegrationsLogo = styled.div`
	background-color: var(--grey-44);
	display: flex;
	justify-content: center;
	align-items: center;
	height: 150px;

	img {
		height: 20px;
		max-width: 140px;

		@media ${device.sm} {
			height: 30px;
			max-width: 170px;
		}
	}
`

export const IntegrationsCopy = styled.div`
	display: block;
	padding: 20px;

	h3 {
		font-size: var(--font-base-size);
	}
`

export const GridMedia = styled.div`
	img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
`

const centerContent = ({ center }) => {
	if (center) {
		return css`
			align-items: center;
			> div,
			> p {
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				text-align: center;
			}

			a.button {
				margin: 0 auto;
			}
		`
	}
	return null
}

export const GridContent = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;

	a.button {
		margin: 0;
	}

	${centerContent}
`

export const GridLink = styled.div`
	margin-top: auto;
	padding-top: 15px;
	width: 100%;
	display: flex;

	a {
		text-decoration: none;
		margin: 0;
	}
`

const borders = ({ border }) => {
	if (border) {
		return css`
			border: 1px solid var(--grey);

			${GridLink} {
				justify-content: center;
				align-items: center;
			}

			${GridContent} {
				align-items: center;
				padding: 15px;
				background: #fff;

				> div,
				> p,
				> h3 {
					display: flex;
					flex-direction: column;
					justify-content: flex-start;
					text-align: center;
				}
			}

			${GridMedia} {
				background: #fff;

				img {
					object-fit: cover;
				}
			}
		`
	}
	return null
}

export const GridColumn = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;

	${borders}
`

export const GridSection = styled(Container)`
	display: flex;
	flex-direction: column;

	h2 {
		margin-bottom: 50px;
	}
`

export const ThreeColumnRow = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 20px;

	@media ${device.sm} {
		grid-template-columns: 1fr 1fr 1fr;
	}

	@media ${device.md} {
		img {
			height: 200px;
		}
	}

	@media ${device.lg} {
		img {
			height: 350px;
		}
	}
`

export const FourColumnRow = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 20px;

	@media ${device.sm} {
		grid-template-columns: 1fr 1fr;

		img {
			height: 180px;
		}
	}

	@media ${device.lg} {
		grid-template-columns: 1fr 1fr 1fr 1fr;
		gap: 20px;

		img {
			height: 250px;
		}
	}
`

export const HighlightsRow = styled.div`
	display: grid;
	grid-gap: 3em;
	grid-template-columns: ${(props) => {
		if (props.grid === 'twoColumnHighlights') {
			return '1fr'
		}
		if (props.grid === 'threeColumnHighlights') {
			return 'repeat(auto-fit, minmax(200px, 1fr))'
		}
		if (props.grid === 'fourColumnHighlights') {
			return 'repeat(auto-fit, minmax(200px, 1fr))'
		}
		return null
	}};

	@media ${device.xs} {
		grid-template-columns: ${(props) => {
			if (props.grid === 'twoColumnHighlights') {
				return 'repeat(2, 1fr)'
			}
			return null
		}};
	}

	@media ${device.sm} {
		grid-template-columns: ${(props) => {
			if (props.grid === 'threeColumnHighlights') {
				return 'repeat(3, 1fr)'
			}
			return null
		}};
	}

	@media ${device.md} {
		grid-template-columns: ${(props) => {
			if (props.grid === 'fourColumnHighlights') {
				return 'repeat(4, 1fr)'
			}
			return null
		}};
	}

	img {
		max-height: 50px;
		width: unset;
		max-width: 100%;
		margin: ${(props) => (props.center ? 'auto' : 'initial')};
	}

	${GridMedia} {
		flex: 0 0 50px;
	}

	${GridColumn} {
		border: 2px solid var(--green);
		width: unset;
		padding: 2em;
		gap: 20px;
	}

	${GridLink} {
		position: unset;
		height: unset;
	}

	${GridContent} {
		padding: 0;
	}
`

export const GridCallOutText = styled.h3`
	color: var(--green);
	font-size: 60px;
	font-weight: 600;
`
